var REMOTE_STRINGS_URL = 'https://localized-strings.acorns.com/v1/web/en/en-US.json';
var LEARN_TIPS_URL = 'https://d5riw2gzyynve.cloudfront.net/learn-tips.json';
var LEARN_TIPS_DISABLED = 'learnTipsDisabled';
export { REMOTE_STRINGS_URL, LEARN_TIPS_URL, LEARN_TIPS_DISABLED };